import { render } from "./Moodboard.vue?vue&type=template&id=6faf4332&scoped=true"
import script from "./Moodboard.vue?vue&type=script&lang=js"
export * from "./Moodboard.vue?vue&type=script&lang=js"

import "./Moodboard.vue?vue&type=style&index=0&id=6faf4332&scoped=true&lang=css"
import "./Moodboard.vue?vue&type=style&index=1&id=6faf4332&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faf4332"]])

export default __exports__